<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-form-group#input-group-name(, label="Nombre", label-for="input-name")
      b-form-input#input-name(
        v-model="form.name",
        placeholder="Nombre",
        :state="$v.$dirty ? !$v.form.name.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.name.required") Campo requerido
    b-form-group#input-group-startDay(
      label="Día inicio",
      label-for="input-start"
    )
      b-form-input#input-start(
        v-model="form.startMonthDay",
        type="number",
        placeholder="Día inicio",
        :state="$v.$dirty ? !$v.form.startMonthDay.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.startMonthDay.required") Campo requerido
        b-form-invalid-feedback(:state="$v.form.startMonthDay.integer") Debe se un numero entero
        b-form-invalid-feedback(:state="$v.form.startMonthDay.between")
          | Debe estar entre {{$v.form.startMonthDay.$params.between.min}} y {{$v.form.startMonthDay.$params.between.max}}
    b-form-group#input-group-lastDay(
      label="Día termino",
      label-for="input-last"
    )
      b-form-input#input-last(
        v-model="form.lastMonthDay",
        placeholder="Día termino",
        type="number",
        :state="$v.$dirty ? !$v.form.lastMonthDay.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.lastMonthDay.required") Campo requerido
        b-form-invalid-feedback(:state="$v.form.lastMonthDay.integer") Debe se un numero entero
        b-form-invalid-feedback(:state="$v.form.lastMonthDay.between")
          | Debe estar entre {{$v.form.lastMonthDay.$params.between.min}} y {{$v.form.lastMonthDay.$params.between.max}}
    b-form-group#input-group-order(
      label="Orden",
      label-for="input-order"
    )
      b-form-input#input-order(
        v-model="form.order",
        type="number",
        :state="$v.$dirty ? !$v.form.order.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.order.required") Campo requerido
        b-form-invalid-feedback(:state="$v.form.order.minValue") El valor debe ser positivo
        b-form-invalid-feedback(:state="$v.form.order.integer") Debe se un numero entero
    .modal-footer
      b-button(
        @click="hideModal()",
        variant="outline-muted",
        v-if="action === 'create'"
      ) Cancelar
      b-button.btn-create(type="submit") {{ action === 'create' ? 'Crear' : 'Guardar' }}
</template>
<script>
import { required, minValue, between, integer } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  props: ["selectedService", "action", "hideModal", "makeToast"],
  validations: {
    form: {
      name: { required },
      startMonthDay: { 
        required,
        between: between(1, 31),
        integer
      },
      lastMonthDay: { 
        required,
        between: between(1, 31),
        integer
      },
      order: { 
        required,
        minValue: minValue(0),
        integer
      },
    },
  },
  data() {
    return {
      form: {
        id: this.action === "create" ? null : this.selectedService.id,
        name: this.action === "create" ? null : this.selectedService.name,
        startMonthDay:
          this.action === "create" ? null : this.selectedService.startMonthDay,
        lastMonthDay:
          this.action === "create" ? null : this.selectedService.lastMonthDay,
        order:
          this.action === "create" ? 0 : this.selectedService.order
      },
    };
  },
  methods: {
    ...mapActions(["editService", "createService"]),
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        const payload = this.form;
        const action =
          this.action === "create" ? this.createService : this.editService;
        const response = await action(payload);

        if (response.status === 200 || response.status === 201) {
          this.makeToast("success", response.data.message, "Éxito!");
          this.hideModal();
        } else {
          this.makeToast("danger", response.data, "Ocurrió un error!");
        }
      }
    },
  }
};
</script>